import React from 'react'
import { IconMessageCircle } from '@tabler/icons-react'

interface ComplaintButtonProps {
  className?: string
}

const ComplaintButton: React.FC<ComplaintButtonProps> = ({ className }) => {
  const handleComplaintClick = () => {
    window.location.href = 'tel:4000799168'
  }

  return (
    <div
      className={`flex flex-col items-center justify-center cursor-pointer p-3 bg-white border border-gray-200 transition-all duration-300 hover:scale-105 ${className || ''}`}
      onClick={handleComplaintClick}
    >
      <IconMessageCircle size={28} color="#EF4444" stroke={1.5} />
      <span className="text-gray-500 text-xs font-medium mt-1">联系客服</span>
    </div>
  )
}

export default ComplaintButton
